<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout wrap>
          <v-flex text-xs-left xs12 md8 v-if="showLabelReportList || showStatistics || showLabelReportOrderList || showEstimateList">
            <v-btn flat @click="showLabelReports" class="bw-5" :disabled="isLabelReportView">Label reports</v-btn>
            <v-btn flat @click="showLabelStatistics" class="bw-5" :disabled="isStatisticsView">Label statistics</v-btn>
            <v-btn flat @click="showLabelReportTasks" class="bw-6" :disabled="isTaskView">Label report tasks</v-btn>
            <v-btn flat @click="showLabelReportEstimates" class="bw-4" :disabled="isEstimateView" v-if="false">Estimates</v-btn>
            <v-btn flat @click="openTrackLabelDialog" class="bw-5" style="margin-left: 50px;" v-if="showLabelReportList">Track label no.</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 md4 v-if="showLabelReportList || showStatistics || showLabelReportOrderList || showEstimateList">
            <v-btn flat @click="print" class="bw-3" v-if="showLabelReportList">Print</v-btn>
            <v-btn flat @click="create" class="bw-7" v-if="showLabelReportList">Create new label report</v-btn>
            <v-btn flat @click="confirmBulkApprove" class="bw-4" :disabled="bulkApproveDisabled" v-if="showLabelReportOrderList">Approve</v-btn>
            <v-btn flat @click="createOrder" class="bw-8" v-if="showLabelReportOrderList">Create new label report task</v-btn>
            <v-btn flat @click="createEstimate" class="bw-7" v-if="showEstimateList">Create new estimate</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="currentLabelReport">
            <v-btn flat @click="save" :disabled="saveButtonDisabled" class="bw-3">Save</v-btn>
            <v-btn flat @click="addSequence" :disabled="addSequenceButtonDisabled" class="bw-5">Add sequence</v-btn>
            <v-btn flat @click="confirmDeleteDialog = true" v-if="canDelete" class="bw-3">Delete</v-btn>
            <v-btn flat @click="cancel" class="bw-3">{{ currentLabelReport.id > 0 ? 'Close' : 'Cancel' }}</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="currentLabelReportOrder">
            <v-btn flat @click="saveOrder" :disabled="saveOrderButtonDisabled" class="bw-3">Save</v-btn>
            <v-btn flat @click="confirmDeleteOrderDialog = true" v-if="canDeleteOrder" class="bw-3">Delete</v-btn>
            <v-btn flat @click="cancelOrder" class="bw-3">{{ currentLabelReportOrder.id > 0 ? 'Close' : 'Cancel' }}</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="currentLabelReportTask">
            <v-btn flat @click="approveTask" :disabled="approveButtonDisabled" class="bw-3" style="float: left;">Approve</v-btn>
            <v-btn flat @click="unlockTask" :disabled="unlockButtonDisabled" class="bw-3" style="float: left;">Unlock</v-btn>
            <v-btn flat @click="save" :disabled="saveButtonDisabled" class="bw-3">Save</v-btn>
            <v-btn flat @click="addSequence" :disabled="addSequenceButtonDisabled" class="bw-5">Add sequence</v-btn>
            <v-btn flat @click="cancelTask" class="bw-3">Close</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="currentLabelReportEstimate">
            <v-btn flat @click="createEstimates" :disabled="createEstimatesButtonDisabled" class="bw-3" v-if="!hasEstimates">Create</v-btn>
            <v-btn flat @click="saveEstimate" :disabled="saveButtonDisabled" class="bw-3" v-if="hasEstimates">Save</v-btn>
            <v-btn flat @click="addEstimate" class="bw-5" v-if="hasEstimates">Add estimate</v-btn>
            <v-btn flat @click="confirmDeleteEstimateDialog = true" v-if="canDeleteLabelReportEstimate" class="bw-3">Delete</v-btn>
            <v-btn flat @click="cancelEstimate" class="bw-3">{{ newLabelReportEstimate ? 'Close' : 'Cancel' }}</v-btn>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;" v-if="showLabelReportList">
            <v-autocomplete :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object @change="loadLabelReports" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;" v-if="showLabelReportList">
            <v-autocomplete :items="filteredFilterFields" v-model="filterField" item-text="address.nameAndText" prepend-icon="a-address" return-object @change="loadLabelReports" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;" v-if="showLabelReportList">
            <v-autocomplete :items="filterCategories" v-model="filterCategory" item-text="displayLabel" prepend-icon="a-trees" return-object @change="loadLabelReports" class="categoryFilter">
              <template slot="selection" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
              <template slot="item" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;" v-if="showLabelReportList">
            <v-autocomplete :items="filterLabellers" v-model="filterLabeller" item-text="fullName" prepend-icon="fa-user" return-object @change="loadLabelReports" class="labellerFilter"/>
          </v-flex>

          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;" v-if="showStatistics">
            <v-autocomplete :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object @change="filterStatisticsSupplierChanged" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showStatistics">
            <v-autocomplete :items="filteredFilterFields" v-model="filterField" item-text="name" prepend-icon="a-address" return-object @change="filterStatisticsFieldChanged" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;" v-if="showStatistics">
            <v-autocomplete :items="fieldLabellers" v-model="multipleFilterLabeller" multiple item-text="name" prepend-icon="fa-user" return-object @change="filterStatisticsLabellerChanged" class="labellerFilter" v-if="fieldLabellers && fieldLabellers.length"/>
          </v-flex>
          <v-flex text-xs-left xs12 md2 px-3 style="padding-top: 6px;" v-if="showStatistics">
            <v-autocomplete :items="labelReportStatisticDates" v-model="multipleFilterDates" multiple prepend-icon="event" return-object @change="filterStatisticsDateChanged" class="datesFilter" v-if="labelReportStatisticDates && labelReportStatisticDates.length"/>
          </v-flex>

          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showLabelReportOrderList">
            <v-autocomplete :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object @change="loadLabelReportOrders" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showLabelReportOrderList">
            <v-autocomplete :items="filterFields" v-model="filterField" item-text="address.nameAndText" prepend-icon="a-address" return-object @change="loadLabelReportOrders" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showLabelReportOrderList">
            <v-autocomplete :items="filterLabellers" v-model="filterLabeller" item-text="fullName" prepend-icon="fa-user" return-object @change="loadLabelReportOrders" class="labellerFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showEstimateList">
            <v-autocomplete :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object @change="loadLabelReportEstimates" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showEstimateList">
            <v-autocomplete :items="filterFields" v-model="filterField" item-text="address.nameAndText" prepend-icon="a-address" return-object @change="loadLabelReportEstimates" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showEstimateList">
            <v-autocomplete :items="filterCategories" v-model="filterCategory" item-text="displayLabel" prepend-icon="a-trees" return-object @change="loadLabelReportEstimates" class="categoryFilter">
              <template slot="selection" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
              <template slot="item" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="showLabelReportList">
        <v-layout :style="'max-height: calc(100vh - 190px' + (trackingMode ? ' - 40px' : '') +');'">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="trackingMode ? trackingHeaders : headers" :items="labelReportsWithTotals" hide-actions no-data-text="No label reports found" ref="labelReports" class="labelReportTable">
              <template v-slot:items="props">
                <tr @click="selectLabelReportRow(props.item)" class="selectable" v-if="props.item.id">
                  <td class="text-xs-left">{{ props.item.newSupplier ? props.item.supplier.name : '' }}</td>
                  <td class="text-xs-left">{{ props.item.newField ? props.item.field.address.nameAndText : '' }}</td>
                  <td class="text-xs-left category">
                    <div v-if="props.item.category.color && !(props.item.category.color.secondColor && props.item.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + props.item.category.color.color + ';'"></div>
                    <div v-if="props.item.category.color && props.item.category.color.secondColor && props.item.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + props.item.category.color.color + ', #' + props.item.category.color.color + ' 3px, #' + props.item.category.color.secondColor + ' 3px, #' + props.item.category.color.secondColor + ' 6px);'"></div>
                  </td>
                  <td class="text-xs-left">
                    <div style="display: inline;">{{ props.item.category.displayLabel }}</div>
                  </td>
                  <td class="text-xs-left">{{ props.item.user ? props.item.user.fullName : '' }}</td>
                  <td class="text-xs-right" style="width: 100px !important; padding-right: 15px !important;" v-if="!trackingMode">{{ props.item.total.toLocaleString() }}</td>
                </tr>
                <tr v-if="props.item.type === 'subTotal' && !trackingMode" class="subTotal">
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right" style="height: 23px !important; padding-bottom: 12px !important;">Subtotal</td>
                  <td class="text-xs-right" style="height: 23px !important; padding-bottom: 12px !important; width: 100px !important; padding-right: 15px !important;">{{ props.item.value.toLocaleString() }}</td>
                </tr>
                <tr v-if="props.item.type === 'total' && !trackingMode" class="total">
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right" style="height: 23px !important; padding-top: 12px !important;">Total</td>
                  <td class="text-xs-right" style="height: 23px !important; padding-top: 12px !important; width: 100px !important; padding-right: 15px !important;">{{ props.item.value.toLocaleString() }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-3 v-if="showLabelReportList && trackingMode" >
        <v-layout>
          <v-flex xs12 text-xs-right>
            <v-btn flat @click="loadLabelReports" class="bw-5" v-if="showLabelReportList">End tracking</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="showLabelReportOrderList" >
        <v-layout style="max-height: calc(100vh - 190px);">
          <v-flex text-xs-right style="overflow-y: auto;">
            <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; margin-bottom: 20px;">
              <v-data-table :headers="taskHeaders" :items="labelReportTasks" hide-actions class="labelReportTable" v-if="labelReportTasks.length > 0">
                <template v-slot:items="props">
                  <tr :class="'selectable ' + (props.item.category ? 'awaitingApproval' : 'awaitingApprovalAndMissingCategory')">
                    <td class="text-xs-left labelReportTask" style="padding: 0 0 0 5px !important; width: 30px; background-color: rgba(255, 255, 255, 0.5);">
                      <v-checkbox color="#004d40" v-model="labelReportTasksSelected[props.index].selected" v-if="props.item.category"/>
                    </td>
                    <td class="text-xs-left" @click="selectLabelReportTaskRow(props.item)" >{{ props.item.supplier.name }}</td>
                    <td class="text-xs-left" @click="selectLabelReportTaskRow(props.item)">{{ props.item.field.address.nameAndText }}</td>
                    <td class="text-xs-left" @click="selectLabelReportTaskRow(props.item)">
                      {{ props.item.user.fullName }}
                    </td>
                    <td class="text-xs-left" @click="selectLabelReportTaskRow(props.item)">
                      <div v-html="props.item.category.displayLabelWithIcon" v-if="props.item.category"></div>
                      <div v-html="props.item.categoryName" v-if="!props.item.category"></div>
                    </td>
                    <td class="text-xs-right" @click="selectLabelReportTaskRow(props.item)" style="width: 80px;">{{ props.item.total.toLocaleString() }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px;">
              <v-data-table :headers="orderHeaders" :items="labelReportOrders" hide-actions no-data-text="No label report tasks found" class="labelReportTable">
                <template v-slot:items="props">
                  <tr @click="selectLabelReportOrderRow(props.item)" :class="labelReportOrderRowClass(props.item)">
                    <td class="text-xs-left" style="width: 20%;">{{ props.item.supplier.name }}</td>
                    <td class="text-xs-left" style="width: 30%;">{{ props.item.field.address.nameAndText }}</td>
                    <td class="text-xs-left" style="width: 30%;">
                      <div v-for="(category, i) in props.item.categories" v-bind:key="'cat_' + i">
                        <div v-html="category.displayLabelWithIcon"></div>
                      </div>
                    </td>
                    <td class="text-xs-left" style="width: 20%;">
                      <div v-for="(user, i) in props.item.users" v-bind:key="'usr_' + i">
                        <div class="ml">
                          {{ user.fullName }}
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="showEstimateList" >
        <v-layout style="max-height: calc(100vh - 190px);">
          <v-flex text-xs-right style="overflow-y: auto;">
            <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px;">
              <v-data-table :headers="estimateHeaders" :items="labelReportEstimatesWithTotals" hide-actions no-data-text="No label report estimates found" class="labelReportTable">
                <template v-slot:items="props">
                  <tr @click="selectLabelReportEstimateRow(props.item)" :class="labelReportEstimateRowClass(props.item)" v-if="props.item.supplier">
                    <td class="text-xs-left" style="width: 30%;">{{ props.item.supplier.name }}</td>
                    <td class="text-xs-left" style="width: 30%;">{{ props.item.field.address.nameAndText }}</td>
                    <td class="text-xs-left">
                      <div v-for="(labelReportEstimate, i) in props.item.labelReportEstimates" v-bind:key="'cat_' + i">
                        <div v-html="labelReportEstimate.category.displayLabelWithIcon"></div>
                      </div>
                    </td>
                    <td class="text-xs-right" style="width: 180px;">
                      <div v-for="(labelReportEstimate, i) in props.item.labelReportEstimates" v-bind:key="'est_' + i">
                        <div v-html="labelReportEstimate.estimate"></div>
                      </div>
                      <div style="width: 100%;">
                        <div class="subTotal" style="display: inline-flex; float: left;">Subtotal</div>
                        <div class="subTotalValue" style="display: inline-flex; float: right; padding-left: 30px;">{{ getLabelReportEstimateTotal(props.item).toLocaleString() }}</div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="props.item.type === 'total'" class="total">
                    <td class="text-xs-right">&nbsp;</td>
                    <td class="text-xs-right">&nbsp;</td>
                    <td class="text-xs-right" style="height: 23px !important; padding-top: 12px !important;">Total</td>
                    <td class="text-xs-right" style="height: 23px !important; padding-top: 12px !important; width: 100px !important; padding-right: 10px !important;">{{ props.item.value.toLocaleString() }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-3 px-3 v-if="showStatistics">
        <v-layout style="max-height: calc(100vh - 200px);">
          <v-flex style="overflow-y: auto;">
            <Panel :title="statField.fieldName" v-for="(statField, i) in labelReportStatistics.fields" :key="'stat_' + i + '_' + updateCounter">
              <div style="overflow-x: auto; padding-top: 5px; padding-bottom: 10px; padding-right: 10px;" class="labelReportTable" v-if="!loadingStatistics">
                <table class="v-datatable v-table theme--light">
                  <thead class="labelReportStatistics">
                    <tr>
                      <th class=""></th>
                      <th class=""></th>
                      <th class=""></th>
                      <th class="rbwe"></th>
                      <th class="tbwe rbwe" colspan="2">{{ showStatisticsTotalFiltered ? 'Field total' : 'Total' }}</th>
                      <th class="nbnp" style="width: 7px !important; min-width: 7px !important;"></th>
                      <th class="tbwe lbwe rbwe" colspan="2" :style="showStatisticsTotalFiltered ? '' : 'display: none;'">Total</th>
                      <th class="tbwe lbwe rbwe" style="padding-top: 4px !important; padding-bottom: 4px !important;" :colspan="labellerDate.labellers.length * 2" v-for="labellerDate in statField.labellerDates" :key="'date_' + labellerDate.date">{{ labellerDate.date !== '' ? labellerDate.date : 'Unknown date' }}</th>
                    </tr>
                    <tr>
                      <th class=""></th>
                      <th class="" style="text-align: left;">Category</th>
                      <th class="">Price</th>
                      <th class="rbwe">Total price</th>
                      <th class="tbw rb">Amount</th>
                      <th class="rbwe tbw">%</th>
                      <th class="nbnp"></th>
                      <th class="tbw lbwe rb" :style="showStatisticsTotalFiltered ? '' : 'display: none;'">Amount</th>
                      <th class="rbwe tbw" :style="showStatisticsTotalFiltered ? '' : 'display: none;'">%</th>
                      <template v-for="labellerDate in statField.labellerDates">
                        <th :class="'tbw ' + (labellerIdx === 0 ? 'lbwe ' : '') + (labellerIdx === labellerDate.labellers.length - 1 ? 'rbwe' : 'rbw')" colspan="2" v-for="(labeller, labellerIdx) in labellerDate.labellers" :key="'labeller_' + labellerDate.date + '_' + labeller.labellerId" :title="labeller.name">
                          {{ labeller.shortName }}<v-icon v-if="labeller.ended" style="margin-left: 5px; font-size: 14px; color: #004d40;">assignment_turned_in</v-icon>
                        </th>
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(row, rowIndex) in statField.rows">
                      <tr v-if="row.type === 'CATEGORY'" :key="'row_' + rowIndex">
                        <td class="tb text-xs-left category" style="padding-top: 2px !important;" v-if="row.category">
                          <div v-if="row.category && row.category.color && !(row.category.color.secondColor && row.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + row.category.color.color + ';'"></div>
                          <div v-if="row.category && row.category.color && row.category.color.secondColor && row.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + row.category.color.color + ', #' + row.category.color.color + ' 3px, #' + row.category.color.secondColor + ' 3px, #' + row.category.color.secondColor + ' 6px);'"></div>
                        </td>
                        <td class="tb rb text text-xs-left" style="min-width: 280px !important; white-space: nowrap;" v-if="row.category">
                          <div style="display: inline;" v-if="row.category">{{ row.category.displayLabel }}</div>
                        </td>
                        <td colspan="2" class="tb rb text-xs-left" style="min-width: 280px !important; white-space: nowrap; padding-left: 18px !important;" v-if="row.categoryName">
                          <div style="display: inline;" v-if="row.categoryName">{{ row.categoryName }}</div>
                        </td>
                        <td class="tb rb text text-xs-right" style="width: 65px; min-width: 65px; padding-right: 10px !important;">
                          {{ row.price ? row.price.toFixed(2) : '' }}
                        </td>
                        <td class="tb rbwe text text-xs-right" style="width: 65px; min-width: 65px; padding-right: 10px !important;">
                          {{ row.totalPrice ? Math.round(row.totalPrice).toLocaleString() : '' }}
                        </td>
                        <td class="tb rb text text-xs-right" style="width: 65px; min-width: 65px; padding-right: 10px !important;">
                          {{ row.totalAmount.toLocaleString() }}
                        </td>
                        <td class="tb rbwe text text-xs-right" style="width: 65px; min-width: 65px; padding-right: 20px !important;">
                          {{ row.totalPct ? row.totalPct.toFixed(0) + ' %' : '' }}
                        </td>
                        <td class="nbnp"></td>
                        <td class="tb lbwe rb text text-xs-right" :style="'width: 65px; min-width: 65px; padding-right: 10px !important;' + (showStatisticsTotalFiltered ? '' : 'display: none;')">
                          {{ row.totalAmountFiltered.toLocaleString() }}
                        </td>
                        <td class="tb rbwe text text-xs-right" :style="'width: 65px; min-width: 65px; padding-right: 20px !important;' + (showStatisticsTotalFiltered ? '' : 'display: none;')">
                          {{ row.totalPctFiltered.toFixed(0) + ' %' }}
                        </td>
                        <template v-for="labellerDate in statField.labellerDates">
                          <template v-for="(labeller, labellerIdx) in labellerDate.labellers">
                            <td :class="'text-xs-right tb rb text' + (labellerIdx === 0 ? ' lbwe' : '')" :key="'ld_' + labellerDate.date + '_' + labeller.labellerId + '_amount'" style="width: 60px; min-width: 60px; padding-right: 10px !important;">{{ getLabellerAmount(row, labellerDate.date, labeller.labellerId).toLocaleString() }}</td>
                            <td :class="'text-xs-right tb text ' + (labellerIdx === labellerDate.labellers.length - 1 ? 'rbwe' : 'rbw')" :key="'ld_' + labellerDate.date + '_' + labeller.labellerId + '_%'" style="width: 60px; min-width: 60px; padding-left: 5px !important; padding-right: 5px !important;" :title="getLabellerPctTitle(row, labellerDate.date, labeller.labellerId)"><div :class="getLabellerDeviationClass(row, labellerDate.date, labeller.labellerId)">{{ getLabellerPct(row, labellerDate.date, labeller.labellerId) }}</div></td>
                          </template>
                        </template>
                      </tr>
                      <tr class="subTotal" v-if="row.type === 'SUB_TOTAL'" :key="'row_s_' + rowIndex">
                        <td colspan="2" class="text-xs-left" style="padding-left: 30px !important; padding-top: 3px !important; padding-bottom: 15px !important;" v-if="row.type === 'SUB_TOTAL'">
                          Sub total
                        </td>
                        <td class="text-xs-right" style="padding-right: 10px !important; padding-top: 3px !important; padding-bottom: 15px !important;">
                          {{ row.price ? row.price.toFixed(2) : '' }}
                        </td>
                        <td class="rbwe text-xs-right" style="padding-right: 10px !important; padding-top: 3px !important; padding-bottom: 15px !important;">
                          {{ row.totalPrice ? Math.round(row.totalPrice).toLocaleString() : '' }}
                        </td>
                        <td class="text-xs-right" style="padding-right: 10px !important; padding-top: 3px !important; padding-bottom: 15px !important;">
                          {{ row.totalAmount.toLocaleString() }}
                        </td>
                        <td class="text-xs-right rbwe" style="padding-right: 20px !important; padding-top: 3px !important; padding-bottom: 15px !important;">
                          {{ row.totalPct ? row.totalPct.toFixed(0) + ' %' : '' }}
                        </td>
                        <td class="nbnp"></td>
                        <td class="lbwe text-xs-right" :style="'padding-right: 10px !important; padding-top: 3px !important; padding-bottom: 15px !important;' + (showStatisticsTotalFiltered ? '' : 'display: none;')">
                          {{ row.totalAmountFiltered.toLocaleString() }}
                        </td>
                        <td class="text-xs-right rbwe" :style="'padding-right: 20px !important; padding-top: 3px !important; padding-bottom: 15px !important;' + (showStatisticsTotalFiltered ? '' : 'display: none;')">
                          {{ row.totalPctFiltered.toFixed(0) + ' %' }}
                        </td>
                        <template v-for="labellerDate in statField.labellerDates">
                          <template v-for="(labeller, labellerIdx) in labellerDate.labellers">
                            <td :class="'text-xs-right tb rb text' + (labellerIdx === 0 ? ' lbwe' : '')" :key="'ld_' + labellerDate.date + '_' + labeller.labellerId + '_amount'" style="width: 60px; min-width: 60px; padding-right: 10px !important; padding-top: 3px !important; padding-bottom: 15px !important;">{{ getLabellerAmount(row, labellerDate.date, labeller.labellerId).toLocaleString() }}</td>
                            <td :class="'text-xs-right tb text ' + (labellerIdx === labellerDate.labellers.length - 1 ? 'rbwe' : 'rbw')" :key="'ld_' + labellerDate.date + '_' + labeller.labellerId + '_%'" style="width: 60px; min-width: 60px; padding-left: 5px !important; padding-right: 5px !important; padding-top: 3px !important; padding-bottom: 15px !important;"><div>{{ getLabellerPct(row, labellerDate.date, labeller.labellerId, 0) }}</div></td>
                          </template>
                        </template>
                      </tr>
                      <tr class="total" v-if="row.type === 'TOTAL'" :key="'row_t_' + rowIndex">
                        <td colspan="2" class="text-xs-left" style="padding-left: 30px !important; padding-top: 12px !important;" v-if="row.type === 'TOTAL'">
                          Total
                        </td>
                        <td class="text-xs-right" style="padding-right: 10px !important; padding-top: 12px !important;">
                          {{ row.price ? row.price.toFixed(2) : '' }}
                        </td>
                        <td class="rbwe text-xs-right" style="padding-right: 10px !important; padding-top: 12px !important;">
                          {{ row.totalPrice ? Math.round(row.totalPrice).toLocaleString() : '' }}
                        </td>
                        <td class="bbwe text-xs-right" style="padding-right: 10px !important; padding-top: 12px !important;">
                          {{ row.totalAmount.toLocaleString() }}
                        </td>
                        <td class="bbwe text-xs-right rbwe" style="padding-right: 20px !important; padding-top: 12px !important;">
                          {{ row.totalPct ? row.totalPct.toFixed(0) + ' %' : '' }}
                        </td>
                        <td class="nbnp"></td>
                        <td class="lbwe bbwe text-xs-right" :style="'padding-right: 10px !important; padding-top: 12px !important;' + (showStatisticsTotalFiltered ? '' : 'display: none;')">
                          {{ row.totalAmountFiltered.toLocaleString() }}
                        </td>
                        <td class="bbwe text-xs-right rbwe" :style="'padding-right: 20px !important; padding-top: 12px !important;' + (showStatisticsTotalFiltered ? '' : 'display: none;')" v-if="showStatisticsTotalFiltered">
                          {{ row.totalPctFiltered.toFixed(0) + ' %' }}
                        </td>
                        <template v-for="labellerDate in statField.labellerDates">
                          <template v-for="(labeller, labellerIdx) in labellerDate.labellers">
                            <td :class="'text-xs-right tb rb bbwe text' + (labellerIdx === 0 ? ' lbwe' : '')" :key="'ld_' + labellerDate.date + '_' + labeller.labellerId + '_amount'" style="width: 60px; min-width: 60px; padding-top: 12px !important; padding-bottom: 6px !important; padding-right: 10px !important;">{{ getLabellerAmount(row, labellerDate.date, labeller.labellerId).toLocaleString() }}</td>
                            <td :class="'text-xs-right tb bbwe text ' + (labellerIdx === labellerDate.labellers.length - 1 ? 'rbwe' : 'rbw')" :key="'ld_' + labellerDate.date + '_' + labeller.labellerId + '_%'" style="width: 60px; min-width: 60px; padding-top: 12px !important; padding-bottom: 6px !important; padding-left: 5px !important; padding-right: 5px !important;"><div>{{ getLabellerPct(row, labellerDate.date, labeller.labellerId, 0) }}</div></td>
                          </template>
                        </template>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <div style="width: 100%; padding-top: 30px; text-align: center;" class="labelReportStatisticsChart" v-if="!loadingStatistics && i < 5">
                <div style="float: right;">
                  <v-btn flat @click="labelReportStatisticChartMode = 'PCT'" class="bw-4" :disabled="labelReportStatisticChartMode === 'PCT'">Percentages</v-btn>
                  <v-btn flat @click="labelReportStatisticChartMode = 'AMOUNT'" class="bw-4" :disabled="labelReportStatisticChartMode === 'AMOUNT'">Amounts</v-btn>
                </div>
                <div :style="'height: ' + (labelReportStatisticChartMode === 'PCT' ? '600' : '600') + 'px; padding-bottom: 20px; margin-left: auto; margin-right: auto; max-width: ' + labelReportStatisticChartMaxWidth(statField) + 'px;'">
                  <a-chart ref="statisticChart" height="100%" width="100%" :options="labelReportStatisticChartOptions(statField, labelReportStatisticChartMode)" :series="labelReportStatisticChartSeries(statField, labelReportStatisticChartMode)"></a-chart>
                </div>
              </div>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentLabelReport">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Label report">
                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-autocomplete :items="suppliers" v-model="currentSupplier" item-text="name" return-object @change="loadFields">
                    <template slot="selection" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Field</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-autocomplete :items="fields" v-model="currentLabelReport.field" item-text="address.nameAndText" return-object>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Category</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-autocomplete :items="categories" v-model="currentLabelReport.category" item-text="displayLabel" return-object>
                    <template slot="selection" slot-scope="data">
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Labeller</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-autocomplete :items="labellerUsersWithEmpty" v-model="currentLabelReport.user" item-text="fullName" return-object>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.fullName }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.fullName }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Adjustment</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-text-field v-model="currentLabelReport.adjustment" class="right-align" style="max-width: 100px;"/>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Total</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  {{ total }}
                </v-flex>

                <v-flex xs12 style="padding-top: 20px; padding-bottom: 20px;">
                  <table>
                    <tr>
                      <th style="text-align: left; width: 120px;">Date</th>
                      <th style="width: 130px; padding-left: 40px;">Amount</th>
                      <th style="width: 200px; padding-left: 50px; padding-right: 15px;">Sequence start</th>
                      <th></th>
                      <th style="width: 200px; padding-left: 15px; padding-right: 50px;">Sequence end</th>
                      <th></th>
                    </tr>
                    <tr v-for="(sequence, i) in currentLabelReport.sequences" v-bind:key="sequence.id">
                      <td style="padding-right: 30px;">
                        <v-menu v-model="reportDateMenu[sequence.id]" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="sequence.reportDate" prepend-icon="event" readonly style="width: 120px;" v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="sequence.reportDate" @input="reportDateMenu[sequence.id] = false"></v-date-picker>
                        </v-menu>
                      </td>
                      <td style="padding-left: 40px;">
                        <v-text-field v-model="sequence.amount" class="right-align" style="max-width: 80px;" v-if="!(sequence.sequenceStart > 0 || sequence.sequenceEnd > 0)"/>
                      </td>
                      <td style="padding-left: 50px; padding-right: 15px;">
                        <v-text-field v-model="sequence.sequenceStart" class="right-align" style="max-width: 160px;" v-if="!(sequence.amount > 0)"/>
                      </td>
                      <td><div v-if="!(sequence.amount > 0)">&rightarrow;</div></td>
                      <td style="padding-left: 15px; padding-right: 50px;">
                        <v-text-field v-model="sequence.sequenceEnd" class="right-align" style="max-width: 160px;" v-if="!(sequence.amount > 0)"/>
                      </td>
                      <td style="padding-left: 10px; width: 35px;">
                        <v-icon v-if="canDeleteSequence(i)" @click="deleteSequence(i)" title="Delete">delete</v-icon>
                      </td>
                    </tr>
                  </table>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentLabelReportOrder">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Label report task">
                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px; padding-bottom: 50px;">
                  <v-autocomplete :items="suppliers" v-model="currentSupplier" item-text="name" return-object @change="loadFields">
                    <template slot="selection" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Field</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px; padding-bottom: 50px;">
                  <v-autocomplete :items="fields" v-model="currentLabelReportOrder.field" item-text="address.nameAndText" return-object>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Categories</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; padding-bottom: 20px;">
                  <v-autocomplete :items="categories" v-model="currentLabelReportOrder.categories" item-text="displayLabel" multiple return-object>
                    <template slot="selection" slot-scope="data">
                      <div style="padding-right: 30px;">
                        <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'display: inline-block; margin: 5px 10px 1px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                        <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'display: inline-block; margin: 5px 10px 1px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                        <div style="display: inline-block; vertical-align: top; padding-top: 5px;">{{ data.item.displayLabel }}</div>
                      </div>
                    </template>
                    <template slot="item" slot-scope="data">
                      <div style="width: 30px; padding-right: 10px !important;">
                        <v-checkbox :input-value="itemSelected(currentLabelReportOrder.categories, data.item)" color="primary" style="width: 30px;"/>
                      </div>
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Labellers</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-autocomplete :items="labellerUsers" v-model="currentLabelReportOrder.users" item-text="fullName" multiple return-object/>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentLabelReportTask">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Label report task">
                <v-flex xs12 sm4 lg2 style="padding-top: 0;">
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="padding-top: 2px;">
                  <div v-html="currentLabelReportTask.supplier.name"></div>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="padding-top: 0;">
                  <v-label>Field</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="padding-top: 2px;">
                  <div v-html="currentLabelReportTask.field.address.nameAndText"></div>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="padding-top: 0;">
                  <v-label>Category</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="padding-top: 2px;">
                  <div v-html="currentLabelReportTask.category.displayLabelWithIcon" v-if="!currentLabelReportTask.categoryName"></div>
                  <div v-html="currentLabelReportTask.categoryName" v-if="currentLabelReportTask.categoryName"></div>
                  <v-autocomplete :items="categories" v-model="currentLabelReportTask.category" item-text="displayLabel" return-object v-if="currentLabelReportTask.categoryName">
                    <template slot="selection" slot-scope="data">
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="padding-top: 0;">
                  <v-label>Labeller</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="padding-top: 2px;">
                  <div v-html="currentLabelReportTask.user.fullName"></div>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Total</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  {{ total }}
                </v-flex>

                <v-flex xs12 style="padding-top: 20px; padding-bottom: 20px;">
                  <table>
                    <tr>
                      <th style="text-align: left; width: 120px;">Date</th>
                      <th style="width: 130px; padding-left: 40px;">Amount</th>
                      <th style="width: 200px; padding-left: 50px; padding-right: 15px;">Sequence start</th>
                      <th></th>
                      <th style="width: 200px; padding-left: 15px; padding-right: 50px;">Sequence end</th>
                      <th></th>
                    </tr>
                    <tr v-for="(sequence, i) in currentLabelReportTask.sequences" v-bind:key="sequence.id">
                      <td style="padding-right: 30px;">
                        <v-menu v-model="reportDateMenu[sequence.id]" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="sequence.reportDate" prepend-icon="event" readonly style="width: 120px;" v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="sequence.reportDate" @input="reportDateMenu[sequence.id] = false"></v-date-picker>
                        </v-menu>
                      </td>
                      <td style="padding-left: 40px;">
                        <v-text-field v-model="sequence.amount" class="right-align" style="max-width: 80px;" v-if="!(sequence.sequenceStart > 0 || sequence.sequenceEnd > 0)"/>
                      </td>
                      <td style="padding-left: 50px; padding-right: 15px;">
                        <v-text-field v-model="sequence.sequenceStart" class="right-align" style="max-width: 160px;" v-if="!(sequence.amount > 0)"/>
                      </td>
                      <td><div v-if="!(sequence.amount > 0)">&rightarrow;</div></td>
                      <td style="padding-left: 15px; padding-right: 50px;">
                        <v-text-field v-model="sequence.sequenceEnd" class="right-align" style="max-width: 160px;" v-if="!(sequence.amount > 0)"/>
                      </td>
                      <td style="padding-left: 10px; width: 35px;">
                        <v-icon v-if="canDeleteSequence(i)" @click="deleteSequence(i)" title="Delete">delete</v-icon>
                      </td>
                    </tr>
                  </table>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentLabelReportEstimate">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Label report estimate">
                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <div v-if="currentLabelReportEstimate.id > 0">{{ currentSupplier.name }}</div>
                  <v-autocomplete :items="suppliers" v-model="currentSupplier" item-text="name" return-object v-if="!currentLabelReportEstimate.id" @change="loadFields">
                    <template slot="selection" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Field</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <div v-if="currentLabelReportEstimate.id > 0">{{ currentLabelReportEstimate.field.address.nameAndText }}</div>
                  <v-autocomplete :items="fieldsWithoutEstimates" v-model="currentLabelReportEstimate.field" item-text="address.nameAndText" return-object v-if="!currentLabelReportEstimate.id">
                    <template slot="selection" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;" v-if="!hasEstimates">
                  <v-label>Categories</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;" v-if="!hasEstimates">
                  <v-autocomplete :items="categories" v-model="selectedCategories" item-text="displayLabel" multiple return-object>
                    <template slot="selection" slot-scope="data">
                      <div style="padding-right: 30px;">
                        <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'display: inline-block; margin: 5px 10px 1px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                        <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'display: inline-block; margin: 5px 10px 1px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                        <div style="display: inline-block; vertical-align: top; padding-top: 5px;">{{ data.item.displayLabel }}</div>
                      </div>
                    </template>
                    <template slot="item" slot-scope="data">
                      <div style="width: 30px; padding-right: 10px !important;">
                        <v-checkbox :input-value="itemSelected(selectedCategories, data.item)" color="primary" style="width: 30px;"/>
                      </div>
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 style="height: 35px;" v-if="hasEstimates">
                  <v-label>Estimates</v-label>
                </v-flex>

                <template v-for="(labelReportEstimate, i) in currentLabelReportEstimate.labelReportEstimates" v-if="hasEstimates">
                  <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px; padding-right: 30px;" v-bind:key="'cat_' + i">
                    <v-autocomplete :items="categories" v-model="labelReportEstimate.category" item-text="displayLabel" return-object>
                      <template slot="selection" slot-scope="data">
                        <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                        <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                        {{ data.item.displayLabel }}
                      </template>
                      <template slot="item" slot-scope="data">
                        <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                        <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                        {{ data.item.displayLabel }}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm4 lg2 style="padding-top: 5px; height: 35px;" v-bind:key="'est_' + i">
                    <table class="noPadding">
                      <tr>
                        <td>
                          <v-text-field v-model="labelReportEstimate.estimate"/>
                        </td>
                        <td style="padding-left: 8px;">
                          <v-icon v-if="canDeleteEstimate(i)" @click="deleteEstimate(i)" title="Delete">delete</v-icon>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </template>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete label report</v-card-title>
        <v-card-text v-if="currentLabelReport">Are you sure you want to delete this label report?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.delete">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDeleteOrderDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Delete label report task</v-card-title>
        <v-card-text v-if="currentLabelReportOrder">Are you sure you want to delete this label report task?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteOrder">Yes</v-btn>
          <v-btn flat @click="confirmDeleteOrderDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmBulkApproveDialog" persistent width="450">
      <v-card pa-5>
        <v-card-title class="headline">Bulk approve</v-card-title>
        <v-card-text>Are you sure you want to approve the selected label reports?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.bulkApprove">Yes</v-btn>
          <v-btn flat @click="confirmBulkApproveDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDeleteEstimateDialog" persistent width="550">
      <v-card pa-5>
        <v-card-title class="headline">Delete estimate</v-card-title>
        <v-card-text v-if="currentLabelReportEstimate && currentLabelReportEstimate.field && currentLabelReportEstimate.field.address">Are you sure you want to delete all estimates for field<br/>"{{ currentLabelReportEstimate.field.address.nameAndText }}"?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteEstimates">Yes</v-btn>
          <v-btn flat @click="confirmDeleteEstimateDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="trackLabelDialog" persistent width="500">
      <v-card pa-5>
        <v-card-title class="headline">Track label no.</v-card-title>
        <v-card-text>
          <v-container fluid py-0 px-3>
            <v-layout wrap>
              <v-flex xs4 style="line-height: 36px;">Category</v-flex>
              <v-flex xs8>
                <v-autocomplete :items="categories" v-model="trackLabelCategory" item-text="displayLabel" return-object class="trackLabelNoCategory">
                  <template slot="selection" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs4 style="line-height: 36px;">Label no.</v-flex>
              <v-flex xs8>
                <v-text-field v-model="trackLabelNo" style="width: 150px;"/>
              </v-flex>
              <v-flex xs12 text-xs-center v-if="trackLabelNoError" class="error-message" style="font-weight: bold; padding-top: 5px;">
                {{ trackLabelNoError }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat class="bw-3" @click="trackLabel" :disabled="!isValidTracking">Track</v-btn>
          <v-btn flat class="bw-3" @click="trackLabelDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import PanelColumn2 from '../components/PanelColumn2'
import DateUtil from '@/assets/javascript/dateutil'
import NumberUtil from '@/assets/javascript/numberutil'
import AChart from 'vue-apexcharts'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'LabelReport',
  components: { Header, Sidebar, Footer, Panel, PanelColumn, PanelColumn2, AChart },
  data () {
    return {
      search: '',
      headers: [
        { text: 'Supplier', value: 'supplier.name', sortable: false },
        { text: 'Field', value: 'field.address.nameAndText', sortable: false },
        { text: '', sortable: false },
        { text: 'Category', value: 'category.label', sortable: false },
        { text: 'Labeller', value: 'user.fullName', sortable: false },
        { text: 'Amount', value: 'total', sortable: false, align: 'end', class: 'labelReportAmountHeader' }
      ],
      trackingHeaders: [
        { text: 'Supplier', value: 'supplier.name', sortable: false },
        { text: 'Field', value: 'field.address.nameAndText', sortable: false },
        { text: '', sortable: false },
        { text: 'Category', value: 'category.label', sortable: false },
        { text: 'Labeller', value: 'user.fullName', sortable: false }
      ],
      orderHeaders: [
        { text: 'Supplier', value: 'supplier.name', sortable: false },
        { text: 'Field', value: 'field.address.nameAndText', sortable: false },
        { text: 'Categories', value: '', sortable: false },
        { text: 'Labellers', value: '', sortable: false }
      ],
      taskHeaders: [
        { text: '', value: '', sortable: false },
        { text: 'Supplier', value: 'supplier.name', sortable: false },
        { text: 'Field', value: 'field.address.nameAndText', sortable: false },
        { text: 'Labeller', value: '', sortable: false },
        { text: 'Category', value: '', sortable: false },
        { text: 'Amount', value: '', sortable: false, align: 'end' }
      ],
      estimateHeaders: [
        { text: 'Supplier', value: 'supplier.name', sortable: false },
        { text: 'Field', value: 'field.address.nameAndText', sortable: false },
        { text: 'Categories', value: '', sortable: false },
        { text: 'Amount', value: '', sortable: false, align: 'end' }
      ],
      labelReports: [],
      labelReportsWithTotals: [],
      labelReportOrders: [],
      labelReportTasks: [],
      labelReportTasksSelected: [],
      labelReportEstimates: [],
      labelReportStatistics: [],
      loadingStatistics: false,
      labelReportStatisticDates: null,
      labelReportStatisticChartMode: 'PCT',
      categories: [],
      suppliers: [],
      fields: [],
      labellerUsers: [],
      labellerUsersWithEmpty: [],
      filterCategories: [],
      filterCategory: { id: 0 },
      filterSuppliers: [],
      filterSupplier: { id: 0 },
      filterFields: [],
      filterField: { id: 0 },
      filterLabellers: [],
      multipleFilterLabellers: [],
      fieldLabellers: [],
      filterLabeller: { id: 0 },
      multipleFilterLabeller: [],
      multipleFilterDates: [],
      view: 'LABEL_REPORT',
      currentSupplier: null,
      currentLabelReport: null,
      currentLabelReportOrder: null,
      currentLabelReportTask: null,
      currentLabelReportEstimate: null,
      newLabelReportEstimate: false,
      confirmDeleteDialog: false,
      confirmDeleteOrderDialog: false,
      confirmDeleteEstimateDialog: false,
      confirmBulkApproveDialog: false,
      trackLabelDialog: false,
      trackLabelCategory: null,
      trackLabelNo: null,
      trackLabelNoError: null,
      trackingMode: false,
      selectedCategories: [],
      reportDateMenu: [],
      showStatisticsTotalFiltered: false,
      updateCounter: 1
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'label_report' })
    this.loadLabelReports()
    this.loadFilterCategories()
    this.loadFilterSuppliers()
    this.loadFilterFields()
    this.loadFilterLabellers()
    this.loadSuppliers()
    this.loadCategories()
    this.loadLabellers()
  },
  computed: {
    isLabelReportView: function () {
      return this.view === 'LABEL_REPORT'
    },
    isStatisticsView: function () {
      return this.view === 'LABEL_STATISTICS'
    },
    isTaskView: function () {
      return this.view === 'TASK'
    },
    isEstimateView: function () {
      return this.view === 'ESTIMATE'
    },
    showLabelReportList: function () {
      return !this.currentLabelReport && !this.currentLabelReportOrder && this.isLabelReportView
    },
    showStatistics: function () {
      return this.isStatisticsView
    },
    showLabelReportOrderList: function () {
      return !this.currentLabelReport && !this.currentLabelReportOrder && !this.currentLabelReportTask && this.isTaskView
    },
    showEstimateList: function () {
      return !this.currentLabelReportEstimate && this.isEstimateView
    },
    users: function () {
      return this.$store.state.user.users
    },
    filteredFilterFields: function () {
      return this.filterSupplier && this.filterSupplier.id > 0 ? this.filterFields.filter(f => f.id === 0 || f.supplierId === this.filterSupplier.id) : this.filterFields
    },
    saveButtonDisabled: function () {
      if (this.currentLabelReport) {
        return !this.currentLabelReport || this.currentLabelReport.category.id === 0 || this.currentLabelReport.field.id === 0 || (!this.sequencesComplete && !this.hasValidAdjustment)
      } else if (this.currentLabelReportTask) {
        return !(this.sequencesComplete || this.currentLabelReportTask.sequences.length === 0)
      } else if (this.currentLabelReportEstimate) {
        return !this.currentLabelReportEstimate || !this.estimatesComplete || (!this.currentLabelReportEstimate.id && !this.currentSupplier)
      }
      return true
    },
    createEstimatesButtonDisabled: function () {
      return !(this.currentLabelReportEstimate && this.currentSupplier && this.currentSupplier.id > 0 && this.currentLabelReportEstimate.field && this.currentLabelReportEstimate.field.id > 0 && this.selectedCategories.length > 0)
    },
    canApprove: function () {
      return this.currentLabelReportTask && this.sequencesComplete
    },
    approveButtonDisabled: function () {
      return !(this.currentLabelReportTask && this.currentLabelReportTask.category && (this.sequencesComplete || this.currentLabelReportTask.sequences.length === 0))
    },
    unlockButtonDisabled: function () {
      return !(this.currentLabelReportTask && (this.sequencesComplete || this.currentLabelReportTask.sequences.length === 0))
    },
    addSequenceButtonDisabled: function () {
      return false
    },
    canDelete: function () {
      return this.currentLabelReport && this.currentLabelReport.id > 0
    },
    sequencesComplete: function () {
      let complete = true
      let sequenceContainer = this.currentLabelReport ? this.currentLabelReport : this.currentLabelReportTask ? this.currentLabelReportTask : null
      if (sequenceContainer && sequenceContainer.sequences && sequenceContainer.sequences.length > 0) {
        for (let seq of sequenceContainer.sequences) {
          let amount = NumberUtil.isPositiveInteger(seq.amount) ? Number(seq.amount) : -1
          let start = NumberUtil.isPositiveInteger(seq.sequenceStart) ? Number(seq.sequenceStart) : -1
          let end = NumberUtil.isPositiveInteger(seq.sequenceEnd) ? Number(seq.sequenceEnd) : -1
          if (!(amount > 0 || (start > 0 && end >= start))) {
            complete = false
            break
          }
        }
      }
      return complete
    },
    hasValidAdjustment: function () {
      if (this.currentLabelReport) {
        return NumberUtil.isPositiveInteger(this.currentLabelReport.adjustment) || NumberUtil.isNegativeInteger(this.currentLabelReport.adjustment)
      }
      return false
    },
    estimatesComplete: function () {
      let complete = false
      if (this.hasEstimates) {
        complete = true
        for (let labelReportEstimate of this.currentLabelReportEstimate.labelReportEstimates) {
          if (!NumberUtil.isZeroOrPositiveInteger(labelReportEstimate.estimate)) {
            complete = false
            break
          }
        }
      }
      return complete
    },
    total: function () {
      let sequenceContainer = this.currentLabelReport ? this.currentLabelReport : this.currentLabelReportTask ? this.currentLabelReportTask : null
      if (sequenceContainer) {
        let total = 0
        for (let seq of sequenceContainer.sequences) {
          let start = NumberUtil.isPositiveInteger(seq.sequenceStart) ? Number(seq.sequenceStart) : -1
          let end = NumberUtil.isPositiveInteger(seq.sequenceEnd) ? Number(seq.sequenceEnd) : -1
          let amount = NumberUtil.isPositiveInteger(seq.amount) ? Number(seq.amount) : -1
          if (amount > 0) {
            total += amount
          } else if (start > 0 && end >= start) {
            total += end - start + 1
          }
        }
        if (this.hasValidAdjustment) {
          total += Number(this.currentLabelReport.adjustment)
        }
        return total
      }
      return 0
    },
    saveOrderButtonDisabled: function () {
      return !this.currentLabelReportOrder || this.currentLabelReportOrder.categories.length === 0 || this.currentLabelReportOrder.field.id === 0 || this.currentLabelReportOrder.users.length === 0
    },
    canDeleteOrder: function () {
      return this.currentLabelReportOrder && this.currentLabelReportOrder.id > 0
    },
    labelReportEstimatesWithTotals: function () {
      let data = []
      if (this.labelReportEstimates && this.labelReportEstimates.length > 0) {
        let total = 0
        for (let labelReportEstimate of this.labelReportEstimates) {
          data.push(labelReportEstimate)
          if (labelReportEstimate.labelReportEstimates && labelReportEstimate.labelReportEstimates.length > 0) {
            for (let est of labelReportEstimate.labelReportEstimates) {
              total += est.estimate
            }
          }
        }
        data.push({
          type: 'total',
          value: total
        })
      }
      return data
    },
    bulkApproveDisabled: function () {
      if (this.labelReportTasksSelected) {
        for (let lrt of this.labelReportTasksSelected) {
          if (lrt.selected) {
            return false
          }
        }
      }
      return true
    },
    isValidTracking: function () {
      return NumberUtil.isZeroOrPositiveInteger(this.trackLabelNo)
    },
    canDeleteLabelReportEstimate: function () {
      return this.currentLabelReportEstimate && this.currentLabelReportEstimate.id > 0
    },
    fieldsWithoutEstimates: function () {
      let data = []
      if (this.fields) {
        for (let field of this.fields) {
          let exists = false
          if (this.labelReportEstimates) {
            for (let labelReportEstimate of this.labelReportEstimates) {
              if (field.id === labelReportEstimate.field.id) {
                exists = true
                break
              }
            }
          }
          if (!exists) {
            data.push(field)
          }
        }
      }
      return data
    },
    hasEstimates: function () {
      return this.currentLabelReportEstimate && this.currentLabelReportEstimate.labelReportEstimates.length > 0
    },
    ...mapGetters({
      sessionSalesOrganizations: 'session/getSalesOrganizations'
    })
  },
  methods: {
    loadLabelReports () {
      this.trackingMode = false
      axios.get('/backend/rest/label_report/summary?category=' + this.filterCategory.id + '&supplier=' + this.filterSupplier.id + '&field=' + this.filterField.id + '&user=' + this.filterLabeller.id)
        .then(response => {
          this.labelReports = response.data
          this.initLabelReportsWithTotals()
        })
    },
    initLabelReportsWithTotals: function () {
      let labelReportsWithTotals = []
      if (this.labelReports && this.labelReports.length > 0) {
        let total = 0
        let subTotal = 0
        let fieldId = 0
        let multipleFields = false
        for (let labelReport of this.labelReports) {
          if (fieldId > 0 && labelReport.field.id !== fieldId) {
            labelReportsWithTotals.push({
              type: 'subTotal',
              value: subTotal
            })
            subTotal = 0
            multipleFields = true
          }
          subTotal += labelReport.total
          total += labelReport.total
          labelReportsWithTotals.push(labelReport)
          fieldId = labelReport.field.id
        }
        if (multipleFields) {
          labelReportsWithTotals.push({
            type: 'subTotal',
            value: subTotal
          })
        }
        labelReportsWithTotals.push({
          type: 'total',
          value: total
        })
        for (let i = 0; i < labelReportsWithTotals.length; i++) {
          labelReportsWithTotals[i].newSupplier = this.isNewSupplier(labelReportsWithTotals, i)
          labelReportsWithTotals[i].newField = this.isNewField(labelReportsWithTotals, i)
        }
      }
      this.labelReportsWithTotals = labelReportsWithTotals
    },
    loadLabelReportOrders () {
      axios.get('/backend/rest/label_report/order?supplier=' + this.filterSupplier.id + '&field=' + this.filterField.id + '&user=' + this.filterLabeller.id)
        .then(response => {
          this.labelReportOrders = response.data
        })
    },
    filterStatisticsSupplierChanged () {
      this.filterField = {
        id: 0
      }
      this.multipleFilterDates = []
      this.loadStatistics()
    },
    filterStatisticsFieldChanged () {
      this.multipleFilterDates = []
      this.loadStatistics()
    },
    filterStatisticsLabellerChanged () {
      this.multipleFilterDates = []
      this.loadStatistics(false)
    },
    filterStatisticsDateChanged () {
      this.loadStatistics(false, false)
    },
    async loadStatistics (reloadLabellers = true, reloadDates = true) {
      if (reloadLabellers) {
        this.multipleFilterLabeller = []
      }
      if (reloadDates) {
        this.multipleFilterDates = []
      }
      let filter = {
        supplier: this.filterSupplier && this.filterSupplier.id ? { id: this.filterSupplier.id } : null,
        field: this.filterField && this.filterField.id ? { id: this.filterField.id } : null,
        labellers: this.multipleFilterLabeller.map((labeller) => { return { id: labeller.labellerId } }),
        reportDates: this.multipleFilterDates
      }

      let labelReportStatistics = null
      let labellers = []
      let labelReportStatisticDates = []
      await axios.post('/backend/rest/label_report/statistics', filter)
        .then(response => {
          labelReportStatistics = response.data
          if (reloadLabellers) {
            if (labelReportStatistics && labelReportStatistics.fields && labelReportStatistics.fields.length) {
              for (let field of labelReportStatistics.fields) {
                if (field.labellerDates && field.labellerDates.length) {
                  for (let labellerDate of field.labellerDates) {
                    if (labellerDate.labellers && labellerDate.labellers.length) {
                      for (let labeller of labellerDate.labellers) {
                        if (!labellers.filter(l => l.labellerId === labeller.labellerId).length) {
                          labellers.push(labeller)
                        }
                      }
                    }
                  }
                }
              }
              labellers.sort(function (f1, f2) {
                return f1.name.localeCompare(f2.name)
              })
            }
          }
          if (reloadDates) {
            if (labelReportStatistics && labelReportStatistics.fields && labelReportStatistics.fields.length) {
              for (let field of labelReportStatistics.fields) {
                if (field.dates && field.dates.length) {
                  for (let date of field.dates) {
                    if (!labelReportStatisticDates.includes(date)) {
                      labelReportStatisticDates.push(date)
                    }
                  }
                }
              }
            }
            labelReportStatisticDates.sort()
          }
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      // Update the data
      this.loadingStatistics = true
      this.labelReportStatistics = labelReportStatistics
      if (reloadLabellers) {
        this.fieldLabellers = labellers
      }
      if (reloadDates) {
        this.labelReportStatisticDates = labelReportStatisticDates
      }
      this.showStatisticsTotalFiltered = ((this.multipleFilterLabeller && this.multipleFilterLabeller.length) || (this.multipleFilterDates && this.multipleFilterDates.length))
      this.loadingStatistics = false
      this.updateCounter++
    },
    loadLabelReportTasks () {
      axios.get('/backend/rest/label_report/task/pendingApproval')
        .then(response => {
          let labelReportTasks = response.data
          let labelReportTasksSelected = []
          for (let lrt of labelReportTasks) {
            labelReportTasksSelected.push({
              id: lrt.id,
              task: lrt,
              selected: false
            })
          }
          this.labelReportTasksSelected = labelReportTasksSelected
          this.labelReportTasks = labelReportTasks
        })
    },
    loadLabelReportEstimates () {
      axios.get('/backend/rest/label_report/estimate?supplier=' + this.filterSupplier.id + '&field=' + this.filterField.id + '&category=' + this.filterCategory.id)
        .then(response => {
          this.labelReportEstimates = response.data
        })
    },
    loadCategories () {
      this.categories = []
      axios.get('/backend/rest/category')
        .then(response => {
          this.categories = response.data
        })
    },
    loadSuppliers () {
      this.suppliers = []
      axios.get('/backend/rest/supplier')
        .then(response => {
          this.suppliers = response.data
          this.suppliers.sort(function (f1, f2) {
            return f1.name.localeCompare(f2.name)
          })
        })
    },
    loadFields () {
      this.fields = []
      axios.get('/backend/rest/field' + (this.currentSupplier && this.currentSupplier.id > 0 ? '/supplier/' + this.currentSupplier.id : ''))
        .then(response => {
          this.fields = response.data
          this.fields.sort(function (f1, f2) {
            return f1.address.nameAndText.localeCompare(f2.address.nameAndText)
          })
        })
    },
    loadLabellers () {
      this.labellerUsers = []
      axios.get('/backend/rest/user/labeller')
        .then(response => {
          this.labellerUsers = response.data
          this.labellerUsersWithEmpty = JSON.parse(JSON.stringify(this.labellerUsers))
          this.labellerUsersWithEmpty.splice(0, 0, {
            id: 0,
            fullName: ''
          })
        })
    },
    loadFilterCategories () {
      axios.get('/backend/rest/category')
        .then(response => {
          this.filterCategories = response.data
          this.filterCategories.splice(0, 0, {
            id: 0,
            displayLabel: ''
          })
        })
    },
    loadFilterSuppliers () {
      axios.get('/backend/rest/supplier')
        .then(response => {
          let filterSuppliers = response.data
          filterSuppliers.splice(0, 0, {
            id: 0,
            name: ''
          })
          filterSuppliers.sort(function (f1, f2) {
            return f1.name.localeCompare(f2.name)
          })
          this.filterSuppliers = filterSuppliers
        })
    },
    loadFilterFields () {
      axios.get('/backend/rest/field')
        .then(response => {
          let filterFields = response.data
          filterFields.splice(0, 0, {
            id: 0,
            address: {
              nameAndText: '',
              name: ''
            }
          })
          filterFields.sort(function (f1, f2) {
            return f1.address.nameAndText.localeCompare(f2.address.nameAndText)
          })
          for (let field of filterFields) {
            field.name = field.address.name && field.address.name !== '' ? field.address.name : field.address.nameAndText
          }
          this.filterFields = filterFields
        })
    },
    loadFilterLabellers () {
      axios.get('/backend/rest/user/labeller')
        .then(response => {
          let filterLabellers = response.data
          filterLabellers.splice(0, 0, {
            id: 0,
            fullName: ''
          })
          filterLabellers.sort(function (f1, f2) {
            return f1.fullName.localeCompare(f2.fullName)
          })
          this.filterLabellers = filterLabellers
          this.multipleFilterLabellers = JSON.parse(JSON.stringify(filterLabellers.filter(fl => fl.id > 0)))
        })
    },
    selectLabelReportRow (item) {
      for (let labelReport of this.labelReports) {
        if (labelReport.id === item.id) {
          this.currentLabelReport = labelReport
          for (let supplier of this.suppliers) {
            if (supplier.id === labelReport.supplier.id) {
              this.currentSupplier = supplier
              break
            }
          }
          break
        }
      }
      this.loadFields()
    },
    selectLabelReportOrderRow (item) {
      this.loadLabellers()
      for (let labelReportOrder of this.labelReportOrders) {
        if (labelReportOrder.id === item.id) {
          this.currentLabelReportOrder = labelReportOrder
          for (let supplier of this.suppliers) {
            if (supplier.id === labelReportOrder.supplier.id) {
              this.currentSupplier = supplier
              break
            }
          }
          break
        }
      }
      this.loadFields()
    },
    selectLabelReportTaskRow (task) {
      for (let labelReportTask of this.labelReportTasks) {
        if (labelReportTask.id === task.id) {
          this.currentLabelReportTask = labelReportTask
          break
        }
      }
    },
    selectLabelReportEstimateRow (item) {
      this.newLabelReportEstimate = false
      for (let labelReportEstimate of this.labelReportEstimates) {
        if (labelReportEstimate.field.id === item.field.id) {
          this.currentLabelReportEstimate = labelReportEstimate
          for (let supplier of this.suppliers) {
            if (supplier.id === labelReportEstimate.supplier.id) {
              this.currentSupplier = supplier
              break
            }
          }
          break
        }
      }
      this.loadFields()
    },
    showLabelReports () {
      this.loadLabelReports()
      this.view = 'LABEL_REPORT'
    },
    showLabelStatistics () {
      this.loadStatistics()
      this.view = 'LABEL_STATISTICS'
    },
    showLabelReportTasks () {
      this.loadLabelReportTasks()
      this.loadLabelReportOrders()
      this.view = 'TASK'
    },
    showLabelReportEstimates () {
      this.loadLabelReportEstimates()
      this.view = 'ESTIMATE'
    },
    print () {
      let filteredItems = this.$refs.labelReports.filteredItems
      let labelReportIds = []
      for (let labelReport of filteredItems) {
        if (labelReport.id) {
          labelReportIds.push(labelReport.id)
        }
      }
      let params = 'labelReports=' + labelReportIds.join(',')
      axios.post('/backend/print/labelReports.xhtml', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/pdf' }), 'Label reports.pdf')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Label reports.pdf')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    create () {
      this.currentSupplier = null
      this.loadCategories()
      this.loadFields()
      this.currentLabelReport = {
        id: 0,
        field: { id: 0 },
        category: { id: 0 },
        adjustment: '',
        sequences: [
          {
            id: 0,
            sequenceStart: '',
            sequenceEnd: ''
          }
        ]
      }
    },
    createOrder () {
      this.currentSupplier = null
      this.loadFields()
      this.loadCategories()
      this.currentLabelReportOrder = {
        id: 0,
        field: { id: 0 },
        categories: [],
        users: []
      }
    },
    addSequence () {
      let sequenceContainer = this.currentLabelReport ? this.currentLabelReport : this.currentLabelReportTask ? this.currentLabelReportTask : null
      sequenceContainer.sequences.push(
        {
          id: -sequenceContainer.sequences.length,
          sequenceStart: '',
          sequenceEnd: '',
          reportDate: DateUtil.dateToString(new Date())
        }
      )
    },
    save () {
      if (this.currentLabelReport) {
        let sequences = []
        for (let seq of this.currentLabelReport.sequences) {
          let amount = NumberUtil.isPositiveInteger(seq.amount) ? Number(seq.amount) : -1
          let start = NumberUtil.isPositiveInteger(seq.sequenceStart) ? Number(seq.sequenceStart) : -1
          let end = NumberUtil.isPositiveInteger(seq.sequenceEnd) ? Number(seq.sequenceEnd) : -1
          if (amount > 0 || (start > 0 && end >= start)) {
            sequences.push(seq)
          }
        }
        this.currentLabelReport.sequences = sequences

        delete this.currentLabelReport.newSupplier
        delete this.currentLabelReport.newField
        axios.post('/backend/rest/label_report', this.currentLabelReport)
          .then(response => {
            this.loadLabelReports()
          })
          .catch(error => {
            console.log(error.response.data.message)
          })
        this.currentLabelReport = null
      } else if (this.currentLabelReportTask) {
        axios.post('/backend/rest/label_report/task', this.currentLabelReportTask)
          .then(response => {
            this.loadLabelReportTasks()
          })
          .catch(error => {
            console.log(error.response.data.message)
          })
        this.currentLabelReportTask = null
      }
    },
    delete () {
      axios.delete('/backend/rest/label_report/' + this.currentLabelReport.id)
        .then(response => {
          this.loadLabelReports()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentLabelReport = null
    },
    cancel () {
      this.currentLabelReport = null
      if (!this.trackingMode) {
        this.loadLabelReports()
      }
    },
    canDeleteSequence (index) {
      if (this.currentLabelReport) {
        return this.currentLabelReport.sequences.length > 1
      } else if (this.currentLabelReportTask) {
        return this.currentLabelReportTask.sequences.length > 0
      }
      return false
    },
    canDeleteEstimate (index) {
      if (this.currentLabelReportEstimate) {
        return this.currentLabelReportEstimate.labelReportEstimates.length > 1
      }
      return false
    },
    deleteSequence (index) {
      let sequenceContainer = this.currentLabelReport ? this.currentLabelReport : this.currentLabelReportTask ? this.currentLabelReportTask : null
      sequenceContainer.sequences.splice(index, 1)
    },
    deleteEstimate (index) {
      this.currentLabelReportEstimate.labelReportEstimates.splice(index, 1)
    },
    saveOrder () {
      axios.post('/backend/rest/label_report/order', this.currentLabelReportOrder)
        .then(response => {
          this.loadLabelReportOrders()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentLabelReportOrder = null
    },
    deleteOrder () {
      axios.delete('/backend/rest/label_report/order/' + this.currentLabelReportOrder.id)
        .then(response => {
          this.loadLabelReportOrders()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteOrderDialog = false
      this.currentLabelReportOrder = null
    },
    cancelOrder () {
      this.currentLabelReportOrder = null
      this.loadLabelReportTasks()
      this.loadLabelReportOrders()
    },
    approveTask () {
      axios.post('/backend/rest/label_report/task/approve', this.currentLabelReportTask)
        .then(response => {
          this.loadLabelReportTasks()
          this.loadLabelReports()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentLabelReportTask = null
    },
    unlockTask () {
      this.currentLabelReportTask.completed = false
      this.currentLabelReportTask.completedTimestamp = null
      this.save()
    },
    cancelTask () {
      this.currentLabelReportTask = null
      this.loadLabelReportTasks()
      this.loadLabelReports()
    },
    itemSelected (items, item) {
      if (item && items && items instanceof Array) {
        for (let i of items) {
          if (i instanceof Object) {
            if (i.id === item.id) {
              return true
            }
          } else if (i === item.id) {
            return true
          }
        }
      }
      return false
    },
    confirmBulkApprove () {
      this.confirmBulkApproveDialog = true
    },
    async bulkApprove () {
      for (let lrt of this.labelReportTasksSelected) {
        if (lrt.selected) {
          await axios.post('/backend/rest/label_report/task/approve', lrt.task)
            .catch(error => {
              console.log(error.response.data.message)
            })
        }
      }
      this.loadLabelReportTasks()
      this.loadLabelReports()
      this.confirmBulkApproveDialog = false
    },
    openTrackLabelDialog () {
      this.trackLabelCategory = null
      this.trackLabelNo = null
      this.trackLabelNoError = null
      this.trackLabelDialog = true
      this.loadLabelReports()
    },
    trackLabel () {
      this.trackLabelNoError = null
      this.trackingMode = false
      axios.get('/backend/rest/label_report/track?category=' + (this.trackLabelCategory ? this.trackLabelCategory.id : 0) + '&labelNumber=' + this.trackLabelNo)
        .then(response => {
          let labelReports = response.data
          if (labelReports && labelReports.length > 0) {
            if (labelReports.length === 1) {
              this.selectLabelReportRow(labelReports[0])
            } else {
              this.trackingMode = true
              this.labelReports = labelReports
            }
            this.trackLabelDialog = false
          } else {
            this.trackLabelNoError = 'Label number was not found'
          }
        })
    },
    createEstimate () {
      this.currentSupplier = null
      this.loadFields()
      this.loadCategories()
      this.newLabelReportEstimate = true
      this.selectedCategories = []
      this.currentLabelReportEstimate = {
        supplier: { id: 0 },
        field: { id: 0 },
        labelReportEstimates: []
      }
    },
    cancelEstimate () {
      for (let i = this.currentLabelReportEstimate.labelReportEstimates.length - 1; i >= 0; i--) {
        let estimate = this.currentLabelReportEstimate.labelReportEstimates[i]
        if (!estimate.category) {
          this.deleteEstimate(i)
        }
      }
      this.loadLabelReportEstimates()
      this.currentLabelReportEstimate = null
    },
    addEstimate () {
      this.currentLabelReportEstimate.labelReportEstimates.push(
        {
          id: -this.currentLabelReportEstimate.labelReportEstimates.length,
          supplier: this.currentSupplier,
          field: this.currentLabelReportEstimate.field,
          category: null,
          estimate: ''
        }
      )
    },
    deleteEstimates () {
      axios.delete('/backend/rest/label_report/estimate/' + this.currentLabelReportEstimate.field.id)
        .then(response => {
          this.loadLabelReportEstimates()
          this.confirmDeleteEstimateDialog = false
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentLabelReportEstimate = null
    },
    saveEstimate () {
      axios.post('/backend/rest/label_report/estimate', this.currentLabelReportEstimate)
        .then(response => {
          this.loadLabelReportEstimates()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentLabelReportEstimate = null
    },
    createEstimates () {
      let estimateId = 0
      for (let cat of this.selectedCategories) {
        this.currentLabelReportEstimate.labelReportEstimates.push(
          {
            id: estimateId,
            supplier: this.currentSupplier,
            field: this.currentLabelReportEstimate.field,
            category: cat,
            estimate: ''
          }
        )
        estimateId--
      }
    },
    isNewSupplier (labelReportsWithTotals, index) {
      if (labelReportsWithTotals && labelReportsWithTotals.length > 0 && index > 0 && index < labelReportsWithTotals.length) {
        return (labelReportsWithTotals[index].type && !labelReportsWithTotals[index - 1].type) || (!labelReportsWithTotals[index].type && labelReportsWithTotals[index - 1].type) || (!labelReportsWithTotals[index].type && labelReportsWithTotals[index].supplier.id !== labelReportsWithTotals[index - 1].supplier.id)
      }
      return true
    },
    isNewField (labelReportsWithTotals, index) {
      if (labelReportsWithTotals && labelReportsWithTotals.length > 0 && index > 0 && index < labelReportsWithTotals.length) {
        return (labelReportsWithTotals[index].type && !labelReportsWithTotals[index - 1].type) || (!labelReportsWithTotals[index].type && labelReportsWithTotals[index - 1].type) || (!labelReportsWithTotals[index].type && labelReportsWithTotals[index].field.id !== labelReportsWithTotals[index - 1].field.id)
      }
      return true
    },
    labelReportOrderRowClass (labelReportOrder) {
      return 'selectable' + (labelReportOrder && labelReportOrder.completed ? ' completed' : '')
    },
    labelReportEstimateRowClass (labelReportEstimate) {
      return 'selectable' + (labelReportEstimate && labelReportEstimate.labelled ? ' labelled' : '')
    },
    getLabelReportEstimateTotal (labelReportEstimate) {
      let totalValue = 0
      for (let e of labelReportEstimate.labelReportEstimates) {
        totalValue += e.estimate
      }
      return totalValue
    },
    getLabellerAmount (row, date, labellerId) {
      if (row && row.groups) {
        let groups = row.groups.filter(g => g.date === date)
        if (groups && groups.length) {
          let group = groups[0]
          if (group && group.records) {
            let records = group.records.filter(r => r.labellerId === labellerId)
            if (records && records.length) {
              return records[0].amount
            }
          }
        }
      }
      return 0
    },
    getLabellerPct (row, date, labellerId, digits = 1) {
      if (row && row.groups) {
        let groups = row.groups.filter(g => g.date === date)
        if (groups && groups.length) {
          let group = groups[0]
          if (group && group.records) {
            let records = group.records.filter(r => r.labellerId === labellerId)
            if (records && records.length) {
              return records[0].pct.toFixed(digits) + ' %'
            }
          }
        }
      }
      return '0 %'
    },
    getLabellerDeviation (row, date, labellerId) {
      if (row && row.groups) {
        let groups = row.groups.filter(g => g.date === date)
        if (groups && groups.length) {
          let group = groups[0]
          if (group && group.records) {
            let records = group.records.filter(r => r.labellerId === labellerId)
            if (records && records.length) {
              return {
                deviation: records[0].deviation,
                text: records[0].deviationText
              }
            }
          }
        }
      }
      return {
        deviation: 'NONE',
        text: ''
      }
    },
    getLabellerDeviationClass (row, date, labellerId) {
      let dev = this.getLabellerDeviation(row, date, labellerId)
      if (dev.deviation === 'ABOVE') {
        return 'above'
      }
      if (dev.deviation === 'BELOW') {
        return 'below'
      }
      return ''
    },
    getLabellerPctTitle (row, date, labellerId) {
      let dev = this.getLabellerDeviation(row, date, labellerId)
      if (dev.text && dev.text !== '') {
        return dev.text
      }
      return ''
    },
    labelReportStatisticChartOptions (labelStatisticsField, mode) {
      let randomColors = [
        '#4040AD',
        '#004D40',
        '#7D7D40',
        '#AD4040',
        '#8080DD',
        '#007D70',
        '#ADAD40',
        '#DD7070',
        '#B0B0FF',
        '#50AD88',
        '#DDDD60',
        '#FFA0A0'
      ]
      let options = {
        colors: [],
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
            show: false
          },
          animations: {
            enabled: false
          }
        },
        dataLabels: {
          style: {
            fontSize: '10px',
            colors: ['#FFFFFF']
          },
          formatter: (val) => {
            return '' // NumberUtil.format(val, 2)
          }
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (value) {
              return [value.shortName, value.date]
            }
          }
        },
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: false
            }
          }
        },
        yaxis: {
          show: mode !== 'PCT',
          max: mode === 'PCT' ? 110 : undefined,
          labels: {
            show: false,
            formatter: (val) => {
              return NumberUtil.format(val, 0)
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            columnWidth: '50%',
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: '11px',
                  fontWeight: 900
                },
                formatter: function (val) {
                  return mode === 'PCT' ? '' : val
                }
              }
            }
          }
        },
        tooltip: {
          enabled: true,
          x: {
            formatter: (value) => {
              return value.name
            }
          },
          y: {
            formatter: (val) => {
              return mode === 'PCT' ? NumberUtil.format(val, 1) + '%' : val
            }
          }
        },
        legend: {
          show: false
        },
        stroke: {
          show: true,
          curve: 'straight',
          lineCap: 'butt',
          colors: ['#004d40'],
          width: 0.5,
          dashArray: 0
        }
      }

      if (labelStatisticsField.rows && labelStatisticsField.rows.length) {
        let colorIndex = 0
        for (let row of labelStatisticsField.rows) {
          if (row.type === 'CATEGORY') {
            if (row.category) {
              options.colors.push('#' + row.category.color.color)
            } else {
              if (colorIndex === randomColors.length) {
                colorIndex = 0
              }
              options.colors.push(randomColors[colorIndex++])
            }
          }
        }
      }

      if (labelStatisticsField.labellerDates && labelStatisticsField.labellerDates.length) {
        if (mode === 'PCT') {
          options.xaxis.categories.push(
            {
              shortName: 'Total',
              name: '',
              date: ''
            }
          )
        }

        for (let labellerDate of labelStatisticsField.labellerDates) {
          for (let labeller of labellerDate.labellers) {
            let datePart = ''
            if (labellerDate.date && labellerDate.date !== '') {
              datePart = DateUtil.extraShortDate(DateUtil.dateStringToDate(labellerDate.date))
            }
            options.xaxis.categories.push(
              {
                shortName: labeller.shortName,
                name: labeller.name,
                date: datePart
              }
            )
          }
        }
      }

      return options
    },
    labelReportStatisticChartSeries (labelStatisticsField, mode) {
      let series = []

      if (labelStatisticsField.rows && labelStatisticsField.rows.length && labelStatisticsField.labellerDates && labelStatisticsField.labellerDates.length) {
        for (let row of labelStatisticsField.rows) {
          if (row.type === 'CATEGORY') {
            let serie = {
              name: row.category ? row.category.displayLabel : row.categoryName,
              data: []
            }

            if (mode === 'PCT') {
              serie.data.push(row.totalPct)
            }

            for (let labellerDate of labelStatisticsField.labellerDates) {
              let date = labellerDate.date
              for (let labeller of labellerDate.labellers) {
                let value = 0
                let groups = row.groups.filter(g => g.date === date)
                if (groups.length) {
                  let records = groups[0].records.filter(r => r.labellerId === labeller.labellerId)
                  if (records.length) {
                    value = mode === 'PCT' ? records[0].pct : records[0].amount
                  }
                }
                serie.data.push(value)
              }
            }

            series.push(serie)
          }
        }
      }

      return series
    },
    labelReportStatisticChartLabellers (labelStatisticsField) {
      let labellers = []
      if (labelStatisticsField.labellers) {
        for (let date in labelStatisticsField.labellers) {
          if (labelStatisticsField.labellers[date].length) {
            for (let l of labelStatisticsField.labellers[date]) {
              if (!labellers.filter(l2 => l2.labellerId === l.labellerId).length) {
                labellers.push(
                  {
                    labellerId: l.labellerId,
                    name: l.name,
                    shortName: l.shortName
                  }
                )
              }
            }
          }
        }
      }
      return labellers
    },
    labelReportStatisticChartMaxWidth (labelStatisticsField) {
      let columns = 0
      for (let labellerDate of labelStatisticsField.labellerDates) {
        columns += labellerDate.labellers.length
      }
      return Math.max(75 + (75 * columns), 300)
    }
  },
  watch: {
    sessionSalesOrganizations () {
      this.filterSupplier = { id: 0 }
      this.filterField = { id: 0 }
      this.loadSuppliers()
      this.loadFilterSuppliers()
      this.loadFields()
      this.loadFilterFields()
      if (this.isLabelReportView) {
        this.loadLabelReports()
      }
      if (this.isStatisticsView) {
        this.loadStatistics()
      }
      if (this.isTaskView) {
        this.loadLabelReportTasks()
        this.loadLabelReportOrders()
      }
      if (this.isEstimateView) {
        this.loadLabelReportEstimates()
      }
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
  .labelReportTaskTable {
    margin-bottom: 20px;
  }
  tr.subTotal td {
    font-weight: bold;
    color: rgba(0, 0, 0, .54);
  }
  div.subTotal {
    font-weight: bold;
    color: rgba(0, 0, 0, .54);
    padding-bottom: 10px;
  }
  div.subTotalValue {
    border-top: 1px solid rgba(0, 0, 0, .54);
    font-weight: bold;
    color: rgba(0, 0, 0, .54);
    padding-bottom: 10px;
  }
  tr.total td {
    font-weight: bold;
    color: rgba(0, 0, 0, .54)
  }
  .labelReportTask .v-input--checkbox {
    padding: 0 !important;
    height: 24px !important;
  }
  table.v-table tbody tr td.category {
    width: 22px !important;
    padding-left: 15px !important;
    padding-right: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/LabelReport.vue